import React from 'react';
import './MoreOptions.css';

interface IChildren {
    children: React.ReactNode;
    disabled?: boolean;
    id?: string;
    dropdownButtonActiveBackgroundColor?: string;
    dropdownButtonTextColor?: string;
    iconFontSize?: string;
    iconMarginTop?: string;
}
const MoreOptionsMenu: React.FC<IChildren> = ({children, id, disabled, dropdownButtonActiveBackgroundColor = "var(--primary-color)", dropdownButtonTextColor = "#fff", iconFontSize = "24px", iconMarginTop}) => {
    return (
        <div
            className={`moreButton ${disabled ? 'disabled' : ''}`}
            id={id}
            style={{
                // Set CSS variables for use in CSS file
                '--menu-icon-show-bg': dropdownButtonActiveBackgroundColor,
                '--menu-icon-show-color': dropdownButtonTextColor,
            } as React.CSSProperties}
        >
            <div
                className="row menu-icon py-1"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <i className="bi bi-three-dots" style={{ fontSize: iconFontSize, marginTop: iconMarginTop }}></i>
            </div>
            {children}
        </div>
    );
};

export default MoreOptionsMenu;
